export interface ILineErrors {
  line: number
  reason: string
}

export interface IFileError {
  field: string
  message: string
}

export interface Import {
  _id: string
  notaryFeeCode?: string
  outstandingBalanceCode?: string
  user: { name: string }
  fileName: string
  lineErrors: ILineErrors[]
  fileError: IFileError[]
  url: string
  createdAt: string
}

export interface IImportFile {
  status: 'starting' | 'failed' | 'succeed'
  _id: string
}

export interface IFees {
  uf: string
  from: number
  to: number
  costValue: number
}

export interface IBalances {
  cpf: string
  amountToPay: number
  relatedContract: string
  remainingInstallmentTerm: number
  overduePaymentCount: number
  amountOverduePayment: number
  dateOfFirstOverduePayment: string
}

export enum IImportTypes {
  notaryFees = 'notaryFees',
  outstandingBalance = 'outstandingBalance'
}
